(function () {
	document.addEventListener("DOMContentLoaded", () => {
		initHeader();
		initFooter();
	});

	/**
	 * Site header — mobile menu toggle, per-item submenu/flyout toggles, and
	 * the Habitaciones room-card hover/focus swap.
	 *
	 * Adapted from monasterio's assets/js/src/monasterio.js (initMenuToggle,
	 * initSubmenuToggles, initMenuImageSwap). Submenus open on click (all
	 * breakpoints) and, at desktop widths, also on hover — see
	 * initSubmenuToggles()'s own docblock for the close-delay that avoids
	 * closing the panel while the mouse is briefly between the link and it.
	 */
	function initHeader() {
		const header = document.querySelector(".site-header");
		if (!header) return;

		initMenuToggle(header);
		initSubmenuToggles(header);
		initRoomCardSwap(header);
		initHeaderScrollState(header);
		// NOT called here — initRoomCarousels() is invoked lazily, from
		// initSubmenuToggles()'s open handler, the first time the
		// Habitaciones panel actually becomes visible. See its
		// docblock.
	}

	function initMenuToggle(header) {
		const toggle = header.querySelector(".menu-toggle");
		const menu = document.getElementById("menu");
		if (!toggle || !menu) return;

		let savedScrollY = 0;
		const setOpen = (isOpen) => {
			toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
			menu.classList.toggle("hidden", !isOpen);
			header.classList.toggle("is-nav-open", isOpen);

			if (isOpen) {
				savedScrollY = window.scrollY;
				document.body.style.overflow = "hidden";
				document.body.style.position = "fixed";
				document.body.style.top = "-" + savedScrollY + "px";
				document.body.style.width = "100%";
			} else {
				document.body.style.overflow = "";
				document.body.style.position = "";
				document.body.style.top = "";
				document.body.style.width = "";
				window.scrollTo(0, savedScrollY);

				// Reset to the Level 1 list — otherwise reopening the mobile
				// menu later would land back on whichever Level 2 panel
				// (Habitaciones or a plain submenu) was left open.
				header.querySelectorAll('.site-nav__toggle[aria-expanded="true"]').forEach((openToggle) => {
					openToggle.setAttribute("aria-expanded", "false");
					const openPanel = document.getElementById(openToggle.getAttribute("aria-controls") || "");
					if (openPanel) openPanel.classList.add("hidden");
					const openItem = openToggle.closest(".site-nav__item");
					if (openItem) openItem.classList.remove("site-nav__item--panel-open");
				});
				header.classList.remove("has-open-submenu");
			}
		};

		toggle.addEventListener("click", () => {
			setOpen(toggle.getAttribute("aria-expanded") !== "true");
		});

		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
				setOpen(false);
				toggle.focus();
			}
		});
	}

	/**
	 * Wires every per-item toggle button — both regular submenus (generated
	 * by the wp_nav_menu walker, see add_menu_item_button() in functions.php)
	 * and the special Habitaciones → #rooms-flyout toggle (same button
	 * markup, aria-controls just points at a hand-built panel instead of a
	 * generated <ul>). Opening one closes any other open one; click outside
	 * or Escape closes whichever is open.
	 *
	 * Also prepends a "back" bar (arrow + italic heading) to every panel —
	 * on mobile this turns the panel into a full "Level 2" screen replacing
	 * Level 1 (see .has-open-submenu in _site-header.scss), matching Figma's
	 * MenuLevel2-Mobile frame instead of an inline accordion. The bar is
	 * hidden by CSS on desktop, where each panel is a dropdown/flyout below
	 * its item instead.
	 *
	 * At desktop widths (matching _site-header.scss's own 1200px dropdown
	 * breakpoint) each item also opens its panel on hover, not just click —
	 * opening waits HOVER_OPEN_DELAY so a pointer just passing over the nav
	 * doesn't pop the panel open, and closing is debounced (HOVER_CLOSE_DELAY) rather than instant on
	 * mouseleave, since #rooms-flyout isn't DOM-nested inside its
	 * .site-nav__item (it's a separate full-width element, see below) and
	 * would otherwise close while the mouse is still travelling from the
	 * "Habitaciones" link down into it. Click still works at every
	 * breakpoint, for touch and keyboard use.
	 */
	function initSubmenuToggles(header) {
		const toggles = Array.from(header.querySelectorAll(".site-nav__toggle"));
		if (!toggles.length) return;

		const navEl = header.querySelector(".site-nav");
		const backLabel = (navEl && navEl.dataset.backLabel) || "Volver";
		const isDesktopNav = () => window.matchMedia("(min-width: 1200px)").matches;
		const HOVER_OPEN_DELAY = 400;
		const HOVER_CLOSE_DELAY = 200;

		const closeToggle = (toggle) => {
			const panel = document.getElementById(toggle.getAttribute("aria-controls") || "");
			toggle.setAttribute("aria-expanded", "false");
			if (panel) panel.classList.add("hidden");
			header.classList.remove("has-open-submenu");
			const item = toggle.closest(".site-nav__item");
			if (item) item.classList.remove("site-nav__item--panel-open");
		};

		const openToggle = (toggle, panel) => {
			if (toggle.getAttribute("aria-expanded") === "true") return;
			toggles.forEach((other) => {
				if (other !== toggle) closeToggle(other);
			});
			toggle.setAttribute("aria-expanded", "true");
			panel.classList.remove("hidden");
			header.classList.add("has-open-submenu");
			// See initRoomCarousels()'s own docblock for why this is lazy.
			requestAnimationFrame(() => initRoomCarousels(panel));
			const item = toggle.closest(".site-nav__item");
			if (item) item.classList.add("site-nav__item--panel-open");
		};

		toggles.forEach((toggle) => {
			const panel = document.getElementById(toggle.getAttribute("aria-controls") || "");
			if (!panel) return;

			if (!panel.querySelector(":scope > .site-nav__panel-back")) {
				const backBar = document.createElement(panel.tagName === "UL" ? "li" : "div");
				backBar.className = "site-nav__panel-back";
				// Real "arrow-left" glyph from Figma (node 5157:13879), not a
				// CSS-only approximation — fill="currentColor" (source has a
				// hardcoded #050C15) so it follows the button's own color.
				backBar.innerHTML =
					'<button type="button" class="site-nav__back">' +
					'<svg class="site-nav__back-icon" width="24" height="11.9568" viewBox="0 0 24 11.9568" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
					'<path d="M23.5 5.45678H1.089C1.164 5.24778 1.287 5.05579 1.453 4.89179L5.401 0.848785C5.594 0.651785 5.59 0.334785 5.392 0.141785C5.195 -0.0502153 4.879 -0.0472155 4.685 0.150785L0.744 4.18678C0.27 4.65378 0.006 5.29178 0 5.95678C0.002 6.61478 0.258 7.25278 0.716 7.71778L4.639 11.8038C4.737 11.9058 4.868 11.9568 5 11.9568C5.125 11.9568 5.25 11.9108 5.346 11.8168C5.545 11.6268 5.552 11.3088 5.361 11.1098L1.433 7.01879C1.273 6.85679 1.154 6.66478 1.082 6.45678H23.5C23.776 6.45678 24 6.23278 24 5.95678C24 5.68078 23.776 5.45678 23.5 5.45678Z" fill="currentColor"/>' +
					"</svg>" +
					'<span class="sr-only"></span>' +
					"</button>" +
					'<p class="site-nav__panel-heading has-h-2-font-size"></p>';
				backBar.querySelector(".sr-only").textContent = backLabel;
				backBar.querySelector(".site-nav__panel-heading").textContent = toggle.textContent.trim();
				panel.prepend(backBar);

				backBar.querySelector(".site-nav__back").addEventListener("click", () => {
					closeToggle(toggle);
					toggle.focus();
				});
			}

			// Mobile "Level 2": the open item's own row (its toggle+link)
			// hides too, so a *nested* submenu (e.g. Gastronomía's <ul>,
			// which lives inside this same <li>) is the only thing left
			// visible — the sibling <li>s themselves are hidden by
			// .has-open-submenu's generic rule below. #rooms-flyout is a
			// separate element outside #menu, so for Habitaciones this
			// just empties out its own row with no other effect.
			toggle.addEventListener("click", () => {
				cancelScheduledOpen();
				if (toggle.getAttribute("aria-expanded") === "true") {
					closeToggle(toggle);
				} else {
					openToggle(toggle, panel);
				}
			});

			const item = toggle.closest(".site-nav__item");
			let openTimer = null;
			let closeTimer = null;
			const cancelScheduledOpen = () => {
				if (openTimer === null) return;
				window.clearTimeout(openTimer);
				openTimer = null;
			};
			const cancelScheduledClose = () => {
				if (closeTimer === null) return;
				window.clearTimeout(closeTimer);
				closeTimer = null;
			};
			const scheduleClose = () => {
				cancelScheduledClose();
				closeTimer = window.setTimeout(() => {
					closeTimer = null;
					closeToggle(toggle);
				}, HOVER_CLOSE_DELAY);
			};
			const openOnHover = () => {
				if (!isDesktopNav()) return;
				cancelScheduledClose();
				cancelScheduledOpen();
				openTimer = window.setTimeout(() => {
					openTimer = null;
					openToggle(toggle, panel);
				}, HOVER_OPEN_DELAY);
			};
			const closeOnHoverOut = () => {
				if (!isDesktopNav()) return;
				cancelScheduledOpen();
				scheduleClose();
			};

			if (item) {
				item.addEventListener("mouseenter", openOnHover);
				item.addEventListener("mouseleave", closeOnHoverOut);
			}
			// #rooms-flyout isn't nested inside .site-nav__item (see docblock
			// above), so it needs its own hover tracking to keep the panel
			// open while the mouse is over it.
			panel.addEventListener("mouseenter", cancelScheduledClose);
			panel.addEventListener("mouseleave", closeOnHoverOut);
		});

		document.addEventListener("click", (event) => {
			if (header.contains(event.target)) return;
			toggles.forEach(closeToggle);
		});

		document.addEventListener("keydown", (event) => {
			if (event.key !== "Escape") return;
			const expandedToggle = toggles.find((t) => t.getAttribute("aria-expanded") === "true");
			if (!expandedToggle) return;
			closeToggle(expandedToggle);
			expandedToggle.focus();
		});
	}

	/**
	 * Swaps the header's secondary CTA (e.g. "Ca la Solita" → "Reservar
	 * hotel") once the visitor scrolls down — see .site-header--scroll in
	 * _site-header.scss and the two header_secondary_link* ACF fields
	 * (Theme Options → Header). No-op if no scroll-variant link is set.
	 */
	function initHeaderScrollState(header) {
		if (!header.querySelector(".site-header__secondary--scroll")) return;

		const threshold = 24;
		const update = () => {
			header.classList.toggle("is-scrolled", window.scrollY > threshold);
		};

		update();
		window.addEventListener("scroll", update, { passive: true });
	}

	/**
	 * Habitaciones flyout: hovering/focusing a room link crossfades the
	 * visible .room-card (matched by data-room-target / data-room-card
	 * index) into the next one, and animates .site-rooms-flyout__cards'
	 * height between the two cards' natural sizes (see .is-animating /
	 * .site-rooms-flyout__cards in _site-header.scss) — cards vary in
	 * height (excerpt/reserve button present or not), so swapping them
	 * instantly otherwise reads as a hard jump. Safe to run unconditionally
	 * on mouseenter/focus because the flyout is already open (click-driven,
	 * see initSubmenuToggles) by the time any of these links can be
	 * interacted with.
	 */
	function initRoomCardSwap(header) {
		const flyout = header.querySelector("#rooms-flyout");
		if (!flyout) return;

		const wrapper = flyout.querySelector(".site-rooms-flyout__cards");
		const links = flyout.querySelectorAll("[data-room-target]");
		const cards = flyout.querySelectorAll("[data-room-card]");
		if (!wrapper || !links.length || !cards.length) return;

		// Matches the longest transition declared on .room-card/
		// .site-rooms-flyout__cards in _site-header.scss (height 300ms) —
		// settle() fires just after both transitions are guaranteed done.
		const TRANSITION_MS = 320;
		let pendingTimeout = null;

		// Fast-forwards any in-flight crossfade to its end state: hides
		// every non-active card, drops the animation styles, and lets the
		// wrapper height go back to auto. Also used as the starting point
		// of every showCard() call so rapid hover changes never leave two
		// cards mid-transition at once.
		const settle = () => {
			cards.forEach((card) => {
				if (!card.classList.contains("is-active")) {
					card.hidden = true;
				}
				card.classList.remove("is-animating");
				card.style.opacity = "";
			});
			wrapper.style.height = "";
		};

		const showCard = (index) => {
			const nextCard = flyout.querySelector(`[data-room-card="${index}"]`);
			const currentCard = flyout.querySelector(".room-card.is-active");
			if (!nextCard || nextCard === currentCard) return;

			window.clearTimeout(pendingTimeout);
			settle();

			const startHeight = wrapper.offsetHeight;

			nextCard.hidden = false;
			nextCard.classList.add("is-animating");
			nextCard.style.opacity = "0";
			if (currentCard) currentCard.classList.add("is-animating");

			// Reading offsetHeight forces layout, committing the styles set
			// above so the opacity/height changes below actually animate
			// instead of collapsing into their end state with no transition.
			const endHeight = nextCard.offsetHeight;

			wrapper.style.height = `${startHeight}px`;
			void wrapper.offsetHeight;
			wrapper.style.height = `${endHeight}px`;

			if (currentCard) currentCard.style.opacity = "0";
			nextCard.style.opacity = "1";
			if (currentCard) currentCard.classList.remove("is-active");
			nextCard.classList.add("is-active");

			pendingTimeout = window.setTimeout(settle, TRANSITION_MS);
		};

		links.forEach((link) => {
			const index = link.getAttribute("data-room-target");
			link.addEventListener("mouseenter", () => showCard(index));
			link.addEventListener("focus", () => showCard(index));
		});
	}

	/**
	 * Initializes a Swiper carousel (assets registered by omitsis-base-plugin
	 * as "ob-swiper"/"ob-swiper", see block.json script deps convention) on
	 * every multi-image room card within `scope`. Cards with a
	 * single image render without the wrapper's nav/pagination controls —
	 * see site-header.php.
	 *
	 * Called lazily from initSubmenuToggles()'s open handler — NOT eagerly
	 * on page load — because #rooms-flyout starts hidden
	 * (display:none). Swiper computes its slide width against the
	 * container's clientWidth at construction time; a zero-width container
	 * makes it compute a garbage/huge value that persists (a real bug hit
	 * during testing: a 2-image gallery inflated to millions of px wide,
	 * breaking the whole layout — calling swiper.update() afterwards did NOT
	 * recover from it). Idempotent (skips elements that already have a live
	 * .swiper instance) since a panel can be opened/closed/reopened many
	 * times.
	 */
	function initRoomCarousels(scope) {
		if (typeof Swiper === "undefined") return;

		scope.querySelectorAll(".room-card__media.swiper").forEach((el) => {
			if (el.swiper) return;

			// Swiper's loop mode duplicates slides to fake infinite scroll —
			// with only 2 real slides (slidesPerView:1) it can't produce
			// enough duplicates and miscalculates slide width instead of
			// just warning (observed: a multi-million-pixel slide, blowing
			// up the whole layout). 3+ slides is the practical safe minimum.
			const loopEnabled = el.querySelectorAll(".swiper-slide").length > 2;

			new Swiper(el, {
				loop: loopEnabled,
				pagination: {
					el: el.querySelector(".swiper-pagination"),
				},
				navigation: {
					prevEl: el.querySelector(".room-card__nav--prev"),
					nextEl: el.querySelector(".room-card__nav--next"),
				},
			});
		});
	}

	/**
	 * Site footer — mobile-only accordion for footer-left items that have
	 * children (Habitaciones/Gastronomía/etc. once an editor adds real
	 * sub-links in Appearance → Menus). Deliberately separate from
	 * initSubmenuToggles() above: the footer's expand/collapse is a plain
	 * inline reveal, not a full-screen "Level 2" takeover, so it doesn't
	 * need the header's has-open-submenu/back-bar machinery — own scope,
	 * own classes (.site-footer__toggle / .site-footer__sublist).
	 */
	function initFooter() {
		const footer = document.querySelector(".site-footer");
		if (!footer) return;

		initFooterAccordion(footer);
		initNewsletterForm(footer);
	}

	function initFooterAccordion(footer) {
		const toggles = Array.from(footer.querySelectorAll(".site-footer__toggle"));
		if (!toggles.length) return;

		const closeToggle = (toggle) => {
			const panel = document.getElementById(toggle.getAttribute("aria-controls") || "");
			toggle.setAttribute("aria-expanded", "false");
			if (panel) panel.classList.add("hidden");
		};

		toggles.forEach((toggle) => {
			const panel = document.getElementById(toggle.getAttribute("aria-controls") || "");
			if (!panel) return;

			toggle.addEventListener("click", () => {
				const isOpen = toggle.getAttribute("aria-expanded") === "true";
				toggles.forEach((other) => {
					if (other !== toggle) closeToggle(other);
				});
				toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
				panel.classList.toggle("hidden", isOpen);
			});
		});
	}

	/**
	 * Newsletter subscribe form (CF7, footer): keeps .wpcf7-submit disabled
	 * until every required field is filled and the [acceptance] checkbox is
	 * checked, since CF7 doesn't offer that out of the box. CF7's own
	 * [field*] tags mark required fields with the wpcf7-validates-as-required
	 * class, not the native "required" attribute (CF7 validates them itself
	 * on submit) — so form.checkValidity() alone would always report valid.
	 * field.checkValidity() is still used per field to also enforce e.g.
	 * [email*]'s type=email format. The acceptance checkbox isn't marked
	 * wpcf7-validates-as-required either, so it's checked separately.
	 */
	function initNewsletterForm(footer) {
		footer.querySelectorAll(".site-footer__newsletter .wpcf7-form").forEach((form) => {
			const submit = form.querySelector(".wpcf7-submit");
			const requiredFields = Array.from(form.querySelectorAll(".wpcf7-validates-as-required"));
			const acceptanceCheckboxes = Array.from(form.querySelectorAll(".wpcf7-acceptance input[type='checkbox']"));
			if (!submit || (!requiredFields.length && !acceptanceCheckboxes.length)) return;

			const updateSubmitState = () => {
				const requiredFilled = requiredFields.every((field) => field.value.trim() !== "" && field.checkValidity());
				const accepted = acceptanceCheckboxes.every((checkbox) => checkbox.checked);
				submit.disabled = !(requiredFilled && accepted);
			};

			updateSubmitState();
			form.addEventListener("input", updateSubmitState);
			form.addEventListener("change", updateSubmitState);
			form.addEventListener("wpcf7mailsent", updateSubmitState);
		});
	}
})();
